<template>
  <card>
    <vue-element-loading
      :text="loading.text"
      spinner="bar-fade-scale"
      :color="loading.color"
      :active="loading.active"
      :is-full-screen="false"/>
    <div slot="header">
      <h4 class="title">Nueva Institución</h4>
    </div>
    <div>
      <form id="edit_form">
        <div class="row">
          <div class="col-md-6">
            <fg-input type="text"
                      label="Nombre"
                      placeholder="Nombre de la Institución"
                      v-model="device.name"
                      v-validate="modelValidations.name"
                      name="name"
                      :error="getError('name')"
            >
            </fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text"
                      label="País">
              <el-select
                class="select-primary"
                placeholder="Seleccione un País"
                reserve-keyword
                v-model="device.country"
                v-validate="modelValidations.country"
                name="country"
                :error="getError('country')">
                <el-option
                  v-for="(item, index) in users"
                  :key="item.index"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </fg-input>
          </div>
                  <div class="col-md-6">
            <fg-input type="text"
                      label="Dominio"
                      placeholder="Nombre de el Dominio"
                      v-model="device.domain"
                      v-validate="modelValidations.domain"
                      name="domain"
                      :error="getError('domain')"
            >
            </fg-input>
          </div>
        </div>
        <div class="text-right">
          <button type="submit" class="btn btn-filmker-pink btn-fill btn-sm" @click.prevent="validate">
            Agregar Insitución
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
  import vueElementLoading from 'vue-element-loading'
  import swal from 'sweetalert2'
  import {Dialog, Option, Select} from 'element-ui'

  export default {
    components: {
      vueElementLoading,
      swal,
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
    },
    data() {
      return {
        users: [],
        loadingUsers: false,
        loading: {
          text: 'Please Wait',
          color: '#222',
          active: false
        },
        device: {
          name: '',
          country: '',
        },
        account: {},
        modelValidations: {
          name: {
            required: true
          },
          country: {
            required: true,
          },
            domain: {
            required: true,
          }


        }
      }
    },
        mounted() {
            this.getUsers();
        },
        methods: {
            validate() {
                this.$validator.validateAll().then(isValid => {
                    if (isValid)
                        this.addDevice();
                })
            },
            getUsers() {
                this.axios({
                    url: `conexions.php?datos=2`,
                    method: 'get',
                    headers: {
                        authorization: localStorage.token
                    }
                })
                    .then(response => {
                      this.loadingUsers = false
                      for (let i in response.data.message) {
                        this.users.push(JSON.parse(response.data.message[i]));
                      }
                      this.loadingUsers = true
                    })
                    .catch(error => {
                        this.loadingUsers = false
                    })
            },
            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            addDevice() {
                this.loading.active = true
                this.axios({
                    url: `conexions.php`,
                    method: 'post',
                    data: this.device,
                    headers: {
                        authorization: localStorage.token
                    }
                })
                    .then(response => {
                        this.loading.active = false
                        this.showSwal('success', 'Institucion Creada')
                        this.clearModel()
                    })
                    .catch(error => {
                        this.loading.active = false
                        this.showSwal('error', error.response.data.message)
                    })
            },
            showSwal(type, message) {
                if (type === 'success') {
                    swal.fire({
                        title: message,
                        type: 'success'
                    })
                } else if (type === 'error') {
                    swal.fire({
                        title: message,
                        type: 'warning'
                    })
                }
            },
            clearModel() {
                this.device = {
                    name: '',
                    country: '',
                }
            }
        }
    }

</script>
<style>
  #edit_form label {
    color: #777 !important;
  }

  option {
    background-color: red !important;
  }
</style>
